// extracted by mini-css-extract-plugin
export default {"trabalhos_maruciapiercer":"trabalhos_maruciapiercer_trabalhos_maruciapiercer__Ry6F2"};